/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
# These imports are for client side use only
#
# Generate source: local/cli/src/commands/placements/generate-placement-files.ts
*/
import { asMessageRenderer, type InitializeMessageRenderer, type MessageRendererType } from '@post-office/placement-common/utils/message-renderer';
import jiraIpmIssueToWorkTopBannerRender from '@post-office/browser--jira-pulsar/jira-ipm-issue-to-work-top-banner/placements/in-app/jira-top-banner/render';
import messageTemplateTemplateRender from '@post-office/browser--post-office-template/message-template-template/placements/in-app/jira-top-banner/render';
/* eslint-disable @typescript-eslint/no-explicit-any */
export const renderer: Record<string, (props: any) => JSX.Element | null> = { 'jira-ipm-issue-to-work-top-banner': jiraIpmIssueToWorkTopBannerRender, 'message-template-template': messageTemplateTemplateRender };
const messageRenderer = asMessageRenderer(renderer, 'jira-top-banner');
export const initializeMessageRenderer: InitializeMessageRenderer = messageRenderer.initializeMessageRenderer;
export const MessageRenderer: MessageRendererType = messageRenderer.MessageRenderer;